import React from 'react';
import {
    Modal, ModalHeader, ModalBody, ModalFooter, Button
} from 'reactstrap';

function YesNoModal(props) {
    const yesClick = () => {
        props.toggle();
        if (props.yesClick)
            props.yesClick(true);
    };

    const noClick = () => {
        props.toggle();
        if (props.noClick)
            props.noClick(false);
    }

    return (
        <Modal isOpen={props.open} toggle={props.toggle}>
            <ModalHeader>
                {props.title || 'Confirm'}
            </ModalHeader>
            <ModalBody>
                <div>
                    {props.children || 'Are you sure?'}
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="danr-red" onClick={noClick}><span>No</span></Button>
                <Button color="danr-green" onClick={yesClick}><span>Yes</span></Button>
            </ModalFooter>
        </Modal>
    );
}

export default YesNoModal;